/**
* BloodTypeCompleteController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';BloodTypeCompleteController.$inject = ["$rootScope", "$http", "$state", "$stateParams", "gplansConf", "Authentication", "$analytics", "affilate"];

  angular.
  module('gplans.survey.controllers').
  controller('BloodTypeCompleteController', BloodTypeCompleteController);

  BloodTypeCompleteController.$inject = ['$rootScope', '$http', '$state', '$stateParams', 'gplansConf', 'Authentication', '$analytics', 'affilate'];

  /**
                                                                                                                                                     * @namespace BloodTypeCompleteController
                                                                                                                                                     */
  function BloodTypeCompleteController($rootScope, $http, $state, $stateParams, gplansConf, Authentication, $analytics, affilate) {
    var vm = this;

    activate();

    function activate() {
      if (affilate && affilate.type === 'Clickbank') {
        vm.clickbank = true;
      }

      $analytics.eventTrack('Survey Complete');
    }

    var fetchMetabolicType = function fetchMetabolicType() {
      $http.get(gplansConf.API_URL + '/api/v1/metabolictypes/' + $stateParams.metabolicTypeId + '/').then(function (response) {
        vm.metabolic_type = response.data;
      });
    };
    Authentication.check().then(fetchMetabolicType);

  }
})();